<script lang="ts">
  import Image from './Image.svelte'
  export let size: number = 15
</script>

<Image src="/share/img/krizek-filter.svg" alt="&times;" height={size} width={size} />
